var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/@core/services/auth/auth.service';
import { UserMeService } from '@app/@core/services/user-me/user-me.service';
import { NbMenuService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
var UserMenuComponent = /** @class */ (function () {
    function UserMenuComponent(auth, router, userMeService, notify, translate, menuService) {
        var _this = this;
        this.auth = auth;
        this.router = router;
        this.userMeService = userMeService;
        this.notify = notify;
        this.translate = translate;
        this.menuService = menuService;
        this.menuItems = [];
        this.isLoading = false;
        this.userSubscription = this.userMeService.dataSubject.subscribe(function (user) {
            _this.user = user;
        });
    }
    UserMenuComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.userMeService.getUserInfo(true)];
                    case 1:
                        response = _a.sent();
                        this.userResponse = response;
                        this.user = response.user;
                        this.company = response.company;
                        this.loadMenuItems();
                        this.menuService.onItemClick()
                            .subscribe(function (event) {
                            if (event.tag === 'userMenu' && event.item.target === 'sign-out') {
                                _this.onLogOut();
                            }
                        });
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    UserMenuComponent.prototype.ngOnDestroy = function () {
        this.userSubscription.unsubscribe();
    };
    UserMenuComponent.prototype.onLogOut = function () {
        this.auth.logOut();
    };
    UserMenuComponent.prototype.loadMenuItems = function () {
        var menuItems = this.getMenuItems();
        this.menuItems = [];
        var _loop_1 = function (each) {
            this_1.menuItems.push(each);
            this_1.translate.stream(each.title).subscribe(function (res) {
                each.title = res;
            });
            if (each.hasOwnProperty('children')) {
                var _loop_2 = function (eachChild) {
                    this_1.translate.stream(eachChild.title).subscribe(function (res) {
                        eachChild.title = res;
                    });
                };
                for (var _i = 0, _a = each.children; _i < _a.length; _i++) {
                    var eachChild = _a[_i];
                    _loop_2(eachChild);
                }
            }
        };
        var this_1 = this;
        for (var _i = 0, menuItems_1 = menuItems; _i < menuItems_1.length; _i++) {
            var each = menuItems_1[_i];
            _loop_1(each);
        }
    };
    UserMenuComponent.prototype.getMenuItems = function () {
        return [
            {
                title: 'page.profile.titleShort',
                link: '/profile',
                icon: 'fa fa-user',
            },
            {
                title: 'page.company.my',
                link: this.company ? "/company/" + this.company.id + "/" : '#',
                icon: 'fa fa-city'
            },
            {
                title: 'button.log_out',
                target: 'sign-out',
                icon: 'fa fa-sign-out-alt',
            },
        ];
    };
    return UserMenuComponent;
}());
export { UserMenuComponent };
